import routes from '@/modules/dashboard/dashboard-routes';
import store from './dashboard-store';

export default {
    routes,
    store,
};
